/** Created by azhou on 2019/2/14.*/
<template>
    <!--头部注册步骤条-注册初始化-->
  <div id="regBasic" class="pt-3 p-4 pb-4 mb-5" >
    <progress-bar class="mb-4" @changeStep="changeStep" v-if="userLoginMessage.submit_store_id>0"/>
    <router-view @saveInfo="saveInfo"/>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  import ProgressBar from '../../StoreInfo/BasicInfo/Comps/ProgressBar'

  export default {
    name: 'RegBasicWrap',
    components: { ProgressBar },
    computed: {
      ...mapState(['StoreRoomArr', 'StoreMeetArr','userLoginMessage']),
      ...mapGetters(['storeInfo']),
      sales () {return this.$route.query.sales||0},
    },
    async created () {
      let t = this.storeInfo.type;
      let submit_store_id=this.userLoginMessage.submit_store_id;
      //创建门店如果有ID则调用详情没有则不调用
      if(submit_store_id>0){
        let verify = await this.getStoreInfo({store_id:submit_store_id});
        //如果是认证状态则跳转到最后一步
        if(verify==2){
          this.$router.push({ name: 'regVerify', query: { step: 3,sales:this.sales } });
        }
      }
    },
    methods: {
      ...mapActions(['getStoreInfo', 'getRoomLists', 'getMeetLists', 'saveStoreInfo','HotelsEditAlbum']),
      changeStep (step, pathName) {
        let t = this.storeInfo.verify
        //当前门店认证状态为待审核时不改变步骤
        if (t === 2) return
        let path = { name: pathName, query: { step,sales:this.sales } }
        this.$router.push(path)
      },
      //保存相册信息时的处理函数
      saveInfo (info) {
      if(info.pic_lobby){
          this.HotelsEditAlbum({
            newInfo: info,
            successFun: () => {
              this.getStoreInfo();
              switch (this.storeInfo.type) {
                case 3:
                case 5:
                  this.$router.push({ name: 'regRoomLists', query: { step: 3,sales:this.sales } });
                  break;
                case 6:
                  this.$router.push({ name: 'regVerify', query: { step: 3,sales:this.sales } });
              }
            }
          })
      }else{
        this.saveStoreInfo({
          newInfo: info,
          successFun: () => {
            this.getStoreInfo();
            switch (this.storeInfo.type) {
              case 3:
              case 5:
                this.$router.push({ name: 'regRoomLists', query: { step: 3,sales:this.sales } });
                break;
              case 6:
                this.$router.push({ name: 'regVerify', query: { step: 3,sales:this.sales } });
            }
          }
        })
      }
      },
    }
  }
</script>
